/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {


    config.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider",
    ];

    function config (
        $stateProvider: ng.ui.IStateProvider,
        $urlRouterProvider: ng.ui.IUrlRouterProvider,
        $locationProvider: ng.ILocationProvider) {

        // IContext
        let routeName = 'meevoStore';

        let contexts = [
            {
                name: routeName + '.home', 
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/home/home.html',
                        controller: 'meevo.plugins.meevoStore.HomeController',
                        controllerAs: 'ctrl'
                    }
                },
                noun: Meevo.Model.NounEnum.MeevoStorePage
            },
            {
                name: routeName + '.account',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/account/account.html',
                        controller: 'meevo.plugins.meevoStore.AccountController',
                        controllerAs: 'ctrl'
                    }
                }
            },
            {
                name: routeName + '.paymentMethod',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/paymentMethod/paymentMethod.html',
                        controller: 'meevo.plugins.meevoStore.PaymentMethodController',
                        controllerAs: 'ctrl'
                    }
                }
            },
            {
                name: routeName + '.billingHistory',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/billingHistory/billingHistory.html',
                        controller: 'meevo.plugins.meevoStore.BillingHistoryController',
                        controllerAs: 'ctrl'
                    }
                }
            },
            {
                name: routeName + '.addons',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/addOns/addOns.html',
                        controller: 'meevo.plugins.meevoStore.AddOnsController',
                        controllerAs: 'ctrl'
                    }
                }
             },
            {
                name: routeName + '.integrations',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/integrations/integrations.html',
                        controller: 'meevo.plugins.meevoStore.IntegrationsController',
                        controllerAs: 'ctrl'
                    }
                }
             },
            {
                name: routeName + '.hardware',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/hardware/hardware.html',
                        controller: 'meevo.plugins.meevoStore.HardwareController',
                        controllerAs: 'ctrl'
                    }
                }
            },
            {
                name: routeName + '.techSphere',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/techSphere/techSphere.html',
                        controller: 'meevo.plugins.meevoStore.TechSphereController',
                        controllerAs: 'ctrl'
                    }
                }
            },
            {
                name: routeName + '.newAdpPayroll',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/newToADPPayroll/newToADPPayroll.html',
                        controller: 'meevo.plugins.meevoStore.newToADPPayrollController',
                        controllerAs: 'ctrl'
                    }
                }
            },
            {
                name: routeName + '.existingAdpPayroll',
                sticky: true,
                views: {
                    'storeview': {
                        templateUrl: 'app/plugins/meevoStore/pages/existingAdpPayroll/existingAdpPayroll.html',
                        controller: 'meevo.plugins.meevoStore.existingAdpPayrollController',
                        controllerAs: 'ctrl'
                    }
                }
            }

        ];

        _.forEach(contexts, (state) => {
            $stateProvider.state(state.name, state);
        });

    }


    angular.module('meevo.plugins.meevoStore', []).config(config);
}